import React from "react";
import {DatePicker} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {
    SelectionCard,
    SelectionHeader,
    SelectionTitle,
    SelectionInfo,
    DatePickerContainer,
    StyledDatePicker
} from "../style/CustomerRequestsPage.styles";

const DateSelection = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    totalDays,
    isActive,
    showEndDate = true
}) => {
    const {t} = useTranslation();

    return (
        <SelectionCard $disabled={!isActive}>
            <SelectionHeader>
                <SelectionTitle>2. {t("screens.customerRequests.dateSelection")}</SelectionTitle>
                {showEndDate && totalDays > 0 ? (
                    <SelectionInfo>
                        {t("screens.customerRequests.totalDays", {count: totalDays})}
                    </SelectionInfo>
                ) : null}
            </SelectionHeader>
            <DatePickerContainer>
                <VFlex flex={1} vertical gap={8}>
                    <label
                        style={{
                            fontWeight: 500,
                            fontSize: "14px"
                        }}
                    >
                        {t("screens.customerRequests.startDate")}
                    </label>
                    <StyledDatePicker
                        placeholder={t("screens.customerRequests.selectStartDate")}
                        value={startDate ? moment(startDate) : null}
                        onChange={date => setStartDate(date ? date.toDate() : null)}
                        format="DD.MM.YYYY"
                        style={{width: "100%"}}
                        disabled={!isActive}
                        disabledDate={current =>
                            current && current.isBefore(moment().startOf("day"))
                        }
                    />
                </VFlex>
                {showEndDate && (
                    <VFlex flex={1} vertical gap={8}>
                        <label
                            style={{
                                fontWeight: 500,
                                fontSize: "14px"
                            }}
                        >
                            {t("screens.customerRequests.endDate")}
                        </label>
                        <StyledDatePicker
                            placeholder={t("screens.customerRequests.selectEndDate")}
                            value={endDate ? moment(endDate) : null}
                            onChange={date => setEndDate(date ? date.toDate() : null)}
                            format="DD.MM.YYYY"
                            style={{width: "100%"}}
                            disabled={!isActive}
                            disabledDate={current => {
                                if (!current) return false;
                                const today = moment().startOf("day");
                                const startMoment = startDate
                                    ? moment(startDate).startOf("day")
                                    : null;

                                if (current.isBefore(today)) return true;
                                if (startMoment && current.isBefore(startMoment)) return true;

                                return false;
                            }}
                        />
                    </VFlex>
                )}
            </DatePickerContainer>
        </SelectionCard>
    );
};

export default DateSelection;
